import {HolidayListList} from "./HolidayListList";
import {HolidayListEdit} from "./HolidayListEdit";
import {HolidayListCreate} from "./HolidayListCreate";

export default {
    list: HolidayListList,
    create: HolidayListCreate,
    edit: HolidayListEdit
};
